export default "__VITE_ASSET__HYmtXir9__"